import { createAction } from '@reduxjs/toolkit';

export const setSupportPhone = createAction('[Phone] setSupportPhone');
